import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'
import img from '@/assets/landing/land-korean-glow.webp'

const schema: LandingScreenSchema = {
	order: ['LandingHead', 'LandingTitle', 'LandingImage', 'LandingProgressLoader', 'LandingFooter'],

	components: {
		LandingTitle: (): LandingComponentsConfig['LandingTitle'] => ({
			title: 'Lose weight and feel more radiant with a <span class="text-prime-gradient">Korean Glow Diet Plan</span>',
			size: 'large',
		}),

		LandingImage: (): LandingComponentsConfig['LandingImage'] => ({
			img: img,
			customStyles: {
				height: '257px',
			},
		}),

		LandingProgressLoader: (): LandingComponentsConfig['LandingProgressLoader'] => ({
			duration: 3500,
		}),
	},
}

export default schema
